import { render, staticRenderFns } from "./journal-list.vue?vue&type=template&id=49345341&"
import script from "./journal-list.vue?vue&type=script&lang=js&"
export * from "./journal-list.vue?vue&type=script&lang=js&"
import style0 from "./journal-list.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "journal-list.vue"
export default component.exports